<template>
  <zen-one 
    :showuserinfo="false" 
    :crumbs="crumbs"
    title="Sistem Hasil Bersepadu Kedah (iHasil)"
  >
    <z-page title="Paparan Penyata Pemungut" >

    <!-- <template v-if="form.lkp_penyata_pemungut_status_id == 3">  
        <w-flex justify-space-between class="mb4">
            <div class="xs4"> 
                <z-input 
                  label="Tarikh Slip Bank *" 
                  name="tarikh_slip_bank" 
                  v-model="form.tarikh_slip_bank" 
                  type="date"/>
              </div>
        </w-flex>
         <w-flex justify-space-between class="mb4">
            <div class="xs4"> 
                <z-input 
                  label="No. Slip Bank *"  
                  name="no_slip_bank" 
                  v-model="form.no_slip_bank" 
                  />
              </div>
        </w-flex> 
    </template>
    <br> -->

    <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="submitPemungut" @success="onSuccess">

    <w-card bg-color="" class="">
        <w-flex justify-center align-center>
           
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      No. Penyata Pemungut :
                  </h5>
                  <div class="fw-normal my1 fs-1"> {{form.no_penyata_pemungut}}</div>
            </div>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      Bank :
                  </h5>
                  <div class="fw-normal my1 fs-1">{{form.lkp_bank ? form.lkp_bank.keterangan: ''}} </div>
            </div>
             <div class="xs4">
                  <h5 class="fw-semibold m0">
                      Status :
                  </h5>
                  <div class="fw-normal my1 fs-1"> {{form.status ? form.status.keterangan: ''}}</div>
            </div>
        </w-flex>

        <w-flex justify-left align-left>
                 <div class="xs4">
                      <h5 class="fw-semibold m0">
                          Tarikh :
                      </h5>
                      <div class="fw-normal my1 fs-1"> {{$zutil.dateformat(form.created_at)}} </div>
                </div>
               
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                        No. Akaun
                      </h5>
                      <div class="fw-normal my1 fs-1">{{form.bank ? form.bank.no_akaun : ''}} </div>
                </div>
            <template v-if="form.lkp_penyata_pemungut_status_id == 4">  
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                        Tarikh Batal
                      </h5>
                      <div class="fw-normal my1 fs-1">{{$zutil.dateformat(form.tarikh_batal)}} </div>
                </div>
            </template>
            <template v-else>
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                      </h5>
                      <div class="fw-normal my1 fs-1"> </div>
                </div>
            </template>
        </w-flex>

        <w-flex justify-left align-left>
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                          Kaedah Bayaran :
                      </h5>
                      <div class="fw-normal my1 fs-1">{{form.cara_bayaran ? form.cara_bayaran.keterangan: ''}} </div>
                </div>
            <template v-if="form.lkp_penyata_pemungut_status_id == 3">  
                <div class="xs4"> 
                    <z-input 
                      label="Tarikh Slip Bank *" 
                      name="tarikh_slip_bank" 
                      v-model="form.tarikh_slip_bank" 
                      type="date"/>
                  </div>
             </template>
            <template v-else>  
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                          Tarikh Slip Bank :
                      </h5>
                      <div class="fw-normal my1 fs-1"> {{$zutil.dateformat(form.tarikh_slip_bank)}}</div>
                </div>
            </template>

            <template v-if="form.lkp_penyata_pemungut_status_id == 3">  
                <div class="xs4"> 
                    <z-input 
                      label="Tarikh Resit Perbendahaaraan *" 
                      name="tarikh_resit_perbendaharaan" 
                      v-model="form.tarikh_resit_perbendaharaan" 
                      type="date"/>
                  </div>
             </template>
            <template v-else>  
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                          Tarikh Resit Perbendahaaraan :
                      </h5>
                      <div class="fw-normal my1 fs-1"> {{$zutil.dateformat(form.tarikh_resit_perbendaharaan)}}</div>
                </div>
            </template>
            
        </w-flex> 

        <w-flex justify-space-between class="mb4">
                <template v-if="form.lkp_penyata_pemungut_status_id == 4">  
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                        Catatan Batal
                      </h5>
                      <div class="fw-normal my1 fs-1">{{form.catatan_batal}} </div>
                </div>
            </template>
            <template v-else>
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                      </h5>
                      <div class="fw-normal my1 fs-1"> </div>
                </div>
            </template>
                <template v-if="form.lkp_penyata_pemungut_status_id == 3"> 
                    <div class="xs4"> 
                        <z-input 
                          label="No. Slip Bank *"  
                          name="no_slip_bank" 
                          v-model="form.no_slip_bank" 
                            maxlength="20"
                        />
                        <small style="color: red; font-size: 8pt;">
                            Max 20 aksara
                        </small>
                      </div>
                </template>
                <template v-else>  
                     <div class="xs4">
                          <h5 class="fw-semibold m0">
                              No. Slip Bank :
                          </h5>
                          <div class="fw-normal my1 fs-1"> {{form.no_slip_bank}}</div>
                    </div>
                </template>
                
                <template v-if="form.lkp_penyata_pemungut_status_id == 3"> 
                    <div class="xs4"> 
                        <z-input 
                          label="No. Resit Perbendahaaraan *"  
                          name="no_resit_perbendaharaan" 
                          v-model="form.no_resit_perbendaharaan" 
                          />
                      </div>
                </template>
                <template v-else>  
                     <div class="xs4">
                          <h5 class="fw-semibold m0">
                              No. Resit Perbendahaaraan :
                          </h5>
                          <div class="fw-normal my1 fs-1"> {{form.no_resit_perbendaharaan}}</div>
                    </div>
                </template>
        </w-flex>
       
    </w-card>
   

    <center v-if="loading"><w-progress class="ma1" circle></w-progress></center>


    <w-tabs :items="tabs" :no-slider="false" active-class="primary">  
    <template #item-content.1> 
            <w-flex justify-center align-center>
                <div class="w-card__content content-hardcode">
                    <table class="table-dashboard" width="100%">
                        <thead>
                            <tr>
                                <td>Bil.</td>
                                <td>No. Resit</td>
                                <td>Tarikh Resit</td>
                                <td>Butiran</td>
                                <td>Amaun (RM)</td>
                            </tr>
                        </thead>
                        <tbody>
                        <tr v-for="d, index in form.resit">
                            <td>{{(index+1)}}</td>
                            <td >
                                {{d.no_resit}}
                                <template v-if="d.is_cek_tendang == 1 ">
                                    <template v-if="d.lkp_resit_status_id == 2 ">
                                        (CTL)
                                    </template>
                                </template>
                            </td>
                             <td >
                               <!-- {{$zutil.dateformat(d.tarikh_bayar)}} -->
                               
                               {{d.tarikh_bayar_resit}}
                            </td>
                             <td >
                               <!--  <span v-for="dt, index in d.butiran">
                                    {{dt.keterangan}}
                                </span> -->

                            </td>
                            <td align="right">
                                {{$zutil.currency(d.amaun)}}
                            </td>
                        </tr>
                        <tr >
                          <td colspan="4"><b>Jumlah</b></td>
                          <td align="right"><b>{{$zutil.currency(form.total_ppresit)}}</b></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </w-flex> 
    </template>
    <template #item-content.2>  

        <!-- <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess"> -->
             <!-- <template v-if="form.lkp_penyata_pemungut_status_id == 3">   -->
                <w-flex justify-center align-center>
                    <div class="w-card__content content-hardcode">
                        <table class="table-dashboard" width="100%">
                            <thead>
                                <tr>
                                    <td>Bil.</td>
                                    <td>Vot</td>
                                    <td>Kod Akaun</td>
                                    <td>Amaun (RM)</td>
                                </tr>
                            </thead>
                            <tbody>
                            <tr v-for="dt, index in form.pp_butiran">
                                <td>{{(index+1)}}</td>
                                <td >
                                    {{dt.vot.kod}}<template v-if="dt.vot_kod">|</template>
                                    {{dt.vot.keterangan}}  
                                </td>
                                <td >
                                    {{dt.akaun.kod}}<template v-if="dt.akaun_kod">|</template> {{dt.akaun.keterangan}}
                                </td>
                                <td align="right">
                                    {{$zutil.currency(dt.amaun)}}
                                </td>
                            </tr>
                            <tr >
                              <td colspan="3"><b>Jumlah</b></td>
                              <td align="right"><b>{{$zutil.currency(form.total_butiran)}}</b></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </w-flex>
                <!-- <w-flex class="mt3" wrap align-center justify-end>
                    <w-button bg-color="success" class="mr3" @click="cetak()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                    </w-button>
                     &nbsp;&nbsp;
                    <w-button class="my1" bg-color="primary" dark  @click="send(3)" >
                       <w-icon dark tile class="mr2">fal fa-save</w-icon> Kemas Kini
                    </w-button>
                </w-flex> -->
      <!--   </template>
        <template v-else>  
              <w-flex justify-center align-center class="mt5">
              <div class="w-card__content content-hardcode">                
                <table class="table-dashboard" width="100%">
                    <thead>
                        <tr>
                            <td>Kod Akaun</td>
                            <td>Amaun (RM)</td>
                            <td> <w-icon class="mr1" @click="addItem">fal fa-plus</w-icon></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="dt, index in form.butiran">
                            <td >
                              <z-lookup label="Kod Akaun *" name="akaun" :url='service_utiliti+"lookup/akaun_akhir"' :sort="false" :cache="false" v-model="dt.akaun_id"  :validators="[validators.required]" readonly /> 
                            </td>
                            <td align="right">
                                <z-money
                                        v-model:originalValue="dt.amaun"
                                        required
                                        v-on:keyup="cekAmaun()"
                                    />
                               
                        </tr>
                        
                        
                    </tbody>
                </table>
              </div>

            </w-flex>
        </template> --> 

             
        <!-- </w-form> -->
      </template>
      <template #item-content.3>
              <w-flex justify-center align-center>
                <div class="w-card__content content-hardcode">
                  
                  <template v-if="form.cara_bayaran && form.cara_bayaran.is_cek == 1">
                    <w-flex class="mt3" wrap align-center justify-end>
                      <w-button class="my1" bg-color="primary" dark  @click="janaCek()" >
                          Jana Cek / Bank Draf
                     </w-button> 
                   </w-flex>
                   </template>
                    <table class="table-dashboard" width="100%">
                        <thead>
                            <tr>
                                <td>Bil.</td>
                                <td>Bank Pembayar</td>
                                <td>No. Cek/ Bank Draf</td>
                                <td>Tarikh. Cek/ Bank Draf</td>
                                <td>Cawangan Bank</td>
                                <td>Status</td>
                                <td>Amaun (RM)</td>
                            </tr>
                        </thead>
                        <tbody>
                        <tr v-for="dat, index in form.terimaan_cek">
                            <td>{{(index+1)}}</td>
                            <td >
                                {{dat.lkp_bank_keterangan_cek}}
                            </td>
                             <td >
                                {{dat.no_cek}}
                            </td>
                             <td >
                               <!--  <span v-for="dt, index in d.butiran">
                                    {{dt.keterangan}}
                                </span> -->
                                {{dat.cek_tarikh}}

                            </td>
                            <td >
                                {{dat.cawangan_bank}}
                            </td>
                            <td>
                                <template v-if="dat.status== 0">
                                    Cek Belum Jelas
                                </template>
                                <template v-else-if="dat.status== 1">
                                    Cek Sudah Jelas
                                </template>
                                <template v-else-if="dat.status== 2">
                                    Cek Tak Laku
                                </template>
                                
                            </td>
                            <td align="right">
                                {{$zutil.currency(dat.amaun)}}
                            </td>
                        </tr>
                        <tr >
                          <td colspan="6"><b>Jumlah</b></td>
                          <td align="right"><b>{{$zutil.currency(form.terimaan_cek_total_amaun)}}</b></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </w-flex> 
      </template>
      <template #item-content.4>
       
            <!-- <z-jejak-audit :jejak_audit="form.jejak_audit"/> -->

            <!-- <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess">  -->
        <w-flex justify-center align-center>
          <div class="w-card__content content-hardcode">

              <table class="table-dashboard" width="100%">
                  <thead>
                  <tr>
                      <td >No</td>
                      <td >Tindakan</td>
                      <td >Pengguna</td>
                      <td >Tarikh</td>
                      <td>Catatan</td>
                  </tr>
                  </thead>
                  <tbody>
                  
                      <tr v-for="dt, index in form.jejak_audit">
                          <td class="w-table__cell text-left">
                              {{(index + 1)}}
                          </td>
                          <td class="w-table__cell text-left">
                              {{dt.tindakan_pemungut.keterangan}}
                          </td>
                          <td class="w-table__cell text-left">
                              {{dt.user.name}}
                          </td>
                          <td class="w-table__cell text-left">
                               {{$zutil.dateformat(dt.created_at)}} 
                          </td>
                          <td class="w-table__cell text-left">
                              {{dt.catatan}}
                          </td>
                      </tr>
                      <tr v-if="form.jejak_audit && form.jejak_audit.length == 0">
                          <td class="w-table__cell text-left" colspan="5">
                          </td>
                      </tr>
                  </tbody>
                  
              </table>
            </div>
          </w-flex>
        <!-- </w-form> -->
      </template>

    </w-tabs>
    <w-flex class="mt3" wrap align-center justify-end>
                <template v-if="form.lkp_sumber_id == 2">
                     <w-button class="my1" bg-color="warning" dark  @click="kembali_ibayaq()" >
                         <w-icon dark tile class="mr2">fal fa-times</w-icon> Kembali
                    </w-button>
                </template>
                <template v-else-if="form.lkp_sumber_id == 3">
                     <w-button class="my1" bg-color="warning" dark  @click="kembali_kiosk()" >
                         <w-icon dark tile class="mr2">fal fa-times</w-icon> Kembali
                    </w-button>
                </template>
                <template v-else-if="form.lkp_sumber_id == 1">
                     <w-button class="my1" bg-color="warning" dark  @click="kembali()" >
                         <w-icon dark tile class="mr2">fal fa-times</w-icon> Kembali 
                    </w-button>
                </template>
                &nbsp;&nbsp;
                 <template v-if="(form.lkp_penyata_pemungut_status_id == 3 ) && $zutil.can('Batal Penyata Pemungut Lulus')"> 
                    <w-button class="my1" bg-color="error-dark1" dark  @click="BatalPemungut()" >
                         <w-icon dark tile class="mr2">fal fa-times</w-icon> Batal
                    </w-button>
                &nbsp;&nbsp;
                </template>

                <template v-if="(form.lkp_penyata_pemungut_status_id == 2 || form.lkp_penyata_pemungut_status_id == 1) && $zutil.can('Penyata Pemungut Batal')"> 
                    <w-button class="my1" bg-color="error-dark1" dark  @click="BatalPemungut()" >
                         <w-icon dark tile class="mr2">fal fa-times</w-icon> Batal
                    </w-button>
                &nbsp;&nbsp;
                </template>
                <template v-if="(form.lkp_penyata_pemungut_status_id == 1 ) && $zutil.can('Penyata Pemungut Semakan')">
                    <w-button class="my1" bg-color="primary" dark  @click="send(2)" >
                         <w-icon dark tile class="mr2">fal fa-save</w-icon> Sahkan
                     </w-button> 
                &nbsp;&nbsp;
                </template>

                <template v-if="form.lkp_penyata_pemungut_status_id == 2 && $zutil.can('Penyata Pemungut Kelulusan') && form.penyedia != form.user_login && form.penyemak != form.user_login">
                        <w-button class="my1" bg-color="primary" dark  @click="send(3)" >
                           <w-icon dark tile class="mr2">fal fa-save</w-icon> Lulus
                        </w-button>
                &nbsp;&nbsp;
                </template>
                <template v-else-if="form.lkp_penyata_pemungut_status_id == 3 ">
                    <w-button bg-color="success" class="mr3" @click="cetak()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                    </w-button>
                     &nbsp;&nbsp;
                    <!-- <w-button class="my1" bg-color="primary" dark  @click="send(3)" >
                       <w-icon dark tile class="mr2">fal fa-save</w-icon> Kemas Kini
                    </w-button> -->
                    <w-button class="my1" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent">
                        <w-icon dark tile class="mr2">fal fa-save</w-icon> KemasKini
                    </w-button>
                </template>
                <template else>
                </template>
                     
            </w-flex>
        </w-form>

  
    </z-page>
    <w-dialog
            v-model="dialog.show"
            :fullscreen="dialog.fullscreen"
            :width="dialog.width"
            :persistent="dialog.persistent"
            :persistent-no-animation="dialog.persistentNoAnimation"
            title-class="primary-light1--bg white"
        >
            <template #title>
                <w-icon class="mr2">fal fa-user</w-icon>
                Permohonan Batal Penyata Pemungut
            </template>
            <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess"> 
               <w-flex justify-space-between class="mb4">
                   <z-input 
                        label="Catatan Batal *"  
                        name="catatan_batal" 
                        v-model="form.catatan_batal"
                        :validators="[validators.required]"/>
              </w-flex>
            </w-form>
            

            <template #actions>
                <div class="spacer" />
                  <w-button class="my1" bg-color="primary"  dark :disabled="form.valid === false" :loading="form.submitted && !form.sent" @click="send(4)" >
                         <w-icon dark tile class="mr2">fal fa-save</w-icon> Hantar
                  </w-button>
                    &nbsp;&nbsp;
                <w-button
                    bg-color="grey-light5--bg"
                    @click="dialog.show = false"
                    >Tutup</w-button
                >
            </template>
        </w-dialog>
  </zen-one>
</template>

<script>

import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    
  },
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {
        total_amaun: 0,

  
    resourceurl: this.service_kutipan +'penyata_pemungut',
    reload: true,
    loading: true,
    hantar : {},
    kemas : {},
    dialog: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 1000,
            },
     tabs: [
          { title: 'Senarai Resit', content: '' },
          { title: 'Senarai Kod Akaun', content: '' },
          { title: 'Senarai Cek/Bank Draf', content: '' },
          { title: 'Jejak Audit', content: '' },
      ],
      
      // tabs: [
      //     { title: 'Butiran', content: '' },
      //     { title: 'Jejak Audit', content: '' },
      // ],
      crumbs: [
        { label: 'iHasil', route: '/' },
        { label: 'Penyata Pemungut', route: '/kutipan/pemungut' },
        { label: 'Papar', route: '/kutipan/pemungut/'+this.id },
      ],
    }
  },
    methods: {

    // addItem() {
    //     this.form.butiran.push( {akaun_id : null, amaun : null});
    // },

    // removeItem(index) {
    //     this.form.butiran.splice(index, 1);
    // },

    cekAmaun(){
      this.total_amaun = 0;
      for (var i in this.form.butiran) {
        this.total_amaun = this.total_amaun + parseFloat(this.form.butiran[i].amaun);
        }
    },

    // cekJumlah(dt){
    //   dt.amaun = dt.kuantiti * dt.kadar
    //   this.cekAmaun()
    //   // for (var i in this.form.butiran) {
    //     // }
    // },

    submitPemungut(){
     // alert('asssd');
      this.kemas.tarikh_slip_bank = this.form.tarikh_slip_bank
      this.kemas.no_slip_bank = this.form.no_slip_bank
      this.kemas.tarikh_resit_perbendaharaan = this.form.tarikh_resit_perbendaharaan
      this.kemas.no_resit_perbendaharaan = this.form.no_resit_perbendaharaan
      this.kemas.id = this.form.id
      this.kemas.kemas_kini = 1
        if (this.form.id > 0) {
              // this.$zcomm.update(this.resourceurl + '/'+this.form.id, this.form.id, this.form)
            this.$zcomm.update(this.resourceurl + '/'+this.kemas.id, this.kemas.id, this.kemas)
                  .then(res => {
                      

                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit()
                      }
                  })
                  .catch(err => {

                  })
                  .finally(() => {
                      

                  });
          }
    },
   

    send(status){
      this.hantar.lkp_penyata_pemungut_status_id = status
      this.hantar.id = this.form.id
      this.hantar.kemas_kini = 0
      this.$zcomm.update(this.resourceurl + '/'+this.hantar.id, this.hantar.id, this.hantar)
      // this.$zcomm.update(this.resourceurl + '/'+this.form.id, this.form.id, this.form.lkp_penyata_pemungut_status_id)
                  .then(res => {
                      

                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit()
                      }

                      // this.$inertia.visit(this.$route('kutipan.pemungut.senarai_ibayaq'))
                    if (this.form.lkp_sumber_id == 3) {
                        this.$inertia.visit(this.$route('kutipan.pemungut.senarai_kiosk'))
                    }else if (this.form.lkp_sumber_id == 2) {
                        this.$inertia.visit(this.$route('kutipan.pemungut.senarai_ibayaq'))
                    }else if (this.form.lkp_sumber_id == 1) {
                        this.$inertia.visit(this.$route('kutipan.pemungut.index'))
                    }
                  })
                  .catch(err => {

                  })
                  .finally(() => {
                      

                  });
    
    },
    janaCek(){
      this.$zcomm.update(this.service_kutipan + 'jana_cek/'+this.form.id, this.form.id, this.form)
                  .then(res => {
                      

                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit()
                      }
                      this.$inertia.visit(this.$page.url, { preserveScroll: true })
                      // this.$inertia.visit(this.$route('kutipan.pemungut.index'))
                  })
                  .catch(err => {

                  })
                  .finally(() => {
                      

                  });
    
    },

    kembali(){
         this.$inertia.visit(this.$route('kutipan.pemungut.index'))
    },

    kembali_ibayaq(){
         this.$inertia.visit(this.$route('kutipan.pemungut.senarai_ibayaq'))
    },
    kembali_kiosk(){
         this.$inertia.visit(this.$route('kutipan.pemungut.senarai_kiosk'))
    },

    // onSuccess(){
    //      if (this.form.id > 0) {
    //           this.$zcomm.update(this.resourceurl + '/'+this.form.id, this.form.id, this.form)
    //               .then(res => {
                      

    //                 if (typeof this.onAfterEdit === "function") {
    //                     this.onAfterEdit()
    //                   }
    //               })
    //               .catch(err => {

    //               })
    //               .finally(() => {
                      

    //               });
    //       }
    // },

    cetak(id) {
            window.location.href = this.service_kutipan+'penyata_pemungut/cetak/'+this.id;
        },

    BatalPemungut() {
            this.dialog.show = 1;
    },

    
  
  
  },
  watch: {

  },
  mounted() {
    this.cekAmaun();
    
      
  },
    
}
</script>